import instagram from "../../assets/img/icon-instagram.png";
import facebook from "../../assets/img/icon-facebook.png";
import youtube from "../../assets/img/icon-youtube.svg";
import telegram from "../../assets/img/icon-telegram.png";
import soudcloud from "../../assets/img/icon-soundcloud.png";
import linkedin from "../../assets/img/icon-linkedin.png";
import logoPrevic from "../../assets/img/logo_Previc.png";
import logoForluz from "../../assets/img/logo-forluz-laranja.svg";
import cemig from "../../assets/img/cemig.png";
import cemigsaude from "../../assets/img/logo_cemig_saude.png";
import gasmig from "../../assets/img/gasmig.png";
import taesa from "../../assets/img/taesa.png";
import indi from "../../assets/img/invest_minas-1.png";
import efficientia from "../../assets/img/efficientia.png";
import '../../assets/files/Certificado.pdf';
import googleapp from "../../assets/img/google.png";
import appleapp from "../../assets/img/apple.png";

const Footer = (props: any) => {

  return (
    <>
      <footer
        style={{ position: "inherit", left: 0, bottom: 0, right: 0 }}
        className="footer bg-light px-4"
      >
        <div className="container-fluid py-2">
          <div className="row">
            <div className="col-md-6 col-lg-4">
              <div className="footer__logo-forluz">
                <img src={logoForluz} alt="Logo" />
              </div>

              <div className="footer__desc mt-5">
                <p className="mb-2">
                  {" "}
                  Forluz - Fundação Forluminas de Seguridade Social
                  <span className="footer-size"></span>
                  {/* <p className="mb-2">   </p> */}
                  R. Conde de Linhares, 77 - Cidade Jardim, Belo Horizonte - MG, CEP 30380-030
                  <span className="footer-size"></span>
                  {/* <p className="mb-2">   </p> */}
                  {/* Belo Horizonte - MG{" "} */}
                </p>
                <p>
                  {" "}
                  <strong> 0800 - 090 9090 </strong>{" "}
                </p>
              </div>

              <div className="footer__midias pr-10 my-5">
                <ul className="list-unstyled d-flex align-items-center">
                  <li>
                    <a href="https://www.instagram.com/forluz_oficial/">
                      <img src={instagram} alt="Icone" />
                    </a>
                  </li>
                  <li>
                    <a href=" https://www.facebook.com/forluz.org/">
                      <img src={facebook} alt="Icone" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/user/comunicacaoforluz">
                      <img src={youtube} alt="Icone" />
                    </a>
                  </li>
                  <li>
                    <a href="https://t.me/+rVpfSec-JERhOTIx">
                      <img src={telegram} alt="Icone" />
                    </a>
                  </li>
                  <li>
                    <a href="https://soundcloud.com/forluz">
                      <img src={soudcloud} alt="Icone" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/forluz">
                      <img src={linkedin} alt="Icone" />
                    </a>
                  </li>
                </ul>
              </div>

              <a
                href="../CentralDeAtendimento/central-atendimento"
                className="btn btn-primary py-4 px-5 rounded"
              >
                {" "}
                Central de Atendimento{" "}
              </a>
            </div>

            {/*<div className="logo_box col-md-6 col-lg-4">
              <div className="row justify-content-center d-none d-lg-block">
                <div className="col-12 col-sm-6 col-md-6 col-lg-6">                  
                  <img src={logoGreat} alt="Logo Great" className="logoGreat" />                  
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-6">                  
                  <a href="/docs/certificados/Selo Governança Corporativa.pdf" target="_blank">
                    <img src={logoGovernanca} alt="Selo Governança" className="logoGov" />
                  </a>                  
                </div>
              </div>
              <div className="row justify-content-center d-none d-lg-block">
                <div className="col-12 col-sm-6 col-md-6 col-lg-6">                  
                  <a href="/docs/certificados/Certificado - Sistema de Gestão de Riscos.pdf" target="_blank">
                    <img src={logoISO} alt="Logo ISO" className="logoISO" />
                  </a>                  
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-6">                  
                  <a href="/docs/certificados/Selo Governança de Investimentos - FORLUZ.pdf" target="_blank">
                    <img src={logoGov} alt="Logo Gov" className="logoGov2" />
                  </a>                  
                </div>
              </div>
            </div> */}

            {/* <div className="col-md-6 col-lg-4 d-flex align-items-end justify-content-center container__logos">
              <div className="d-none d-lg-block">
                <div className="d-flex align-items-center justify-content-center flex-column test logo_box">

                  <div className="d-flex">
                    <img src={logoGreat} alt="Logo Great" className="logoGreat" />
                  </div>
                  <div className="d-flex">
                    <a href="/docs/certificados/Selo Governança Corporativa.pdf" target="_blank">
                      <img src={logoGov} alt="Logo Gov" className="logoGov" />
                    </a>
                  </div>
                  <div className="d-flex">
                    <a href="/docs/certificados/Certificado - Sistema de Gestão de Riscos.pdf" target="_blank">
                      <img src={logoISO} alt="Logo ISO" className="logoISO" />
                    </a>
                  </div>
                  <div className="d-flex">
                    <a href="/docs/certificados/Selo Governança Corporativa.pdf" target="_blank">
                      <img src={logoGovernanca} alt="Selo Governança" className="logoGov2" />
                    </a>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="col-lg-4 mx-auto leftM logoPrevic">
              <div className="pb-6 d-none d-lg-block">
                <div className="d-flex align-items-center justify-content-around justify-content-lg-start">
                  <a href="https://www.gov.br/previc/pt-br" target="_blank" rel="noreferrer">
                    <img src={logoPrevic} alt="Logo" />
                  </a>
                </div>
              </div>
              <label className="footer__parceiros d-none d-lg-block">Patrocinadoras</label>
              <div className="footer__clientes pt-4 d-none d-lg-block patrocinadoras">
                <div className="d-flex align-items-center">
                  <div className="patrocinadoras-container">
                    <a href="https://www.cemig.com.br/" target="_blank" rel="noreferrer">
                      <img
                        src={cemig}
                        alt="Logo"
                        className="mx-2 mb-3 mb-xl-0"
                      />
                    </a>
                  </div>
                  <div className="patrocinadoras-container">
                    <a href="https://www.cemigsaude.org.br/site/home" target="_blank" rel="noreferrer">
                      <img
                        src={cemigsaude}
                        alt="Logo"
                        className="mx-2 mb-3 mb-xl-0"
                      />
                    </a>
                  </div>
                  <div className="patrocinadoras-container">
                    <a href="http://www.gasmig.com.br/" target="_blank" rel="noreferrer">
                      <img
                        src={gasmig}
                        alt="Logo"
                        className="mx-2 mb-3 mb-xl-0"
                      />
                    </a>
                  </div>
                </div>
                <br></br>
                <div className="d-flex align-items-center">

                  <div className="patrocinadoras-container">
                    <a rel="noreferrer" href="http://institucional.taesa.com.br/" target="_blank"
                    >
                      <img
                        src={taesa}
                        alt="Logo"
                        className="mx-2 mb-3 mb-xl-0"
                      />
                    </a>
                  </div>
                  <div className="patrocinadoras-container">
                    <a href="https://www.investminas.mg.gov.br/" target="_blank" rel="noreferrer">
                      <img
                        src={indi}
                        alt="Logo"
                        className="mx-2 mb-3 mb-xl-0"
                      />
                    </a>
                  </div>
                  <div className="patrocinadoras-container">
                    <a href="https://cemigsim.com.br/" target="_blank" rel="noreferrer">
                      <img
                        src={efficientia}
                        alt="Logo"
                        className="mx-2 mb-3 mb-xl-0"
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div className="footer__clientes pt-6 d-none d-lg-block">
                <div className="d-flex align-items-center">
                  <a href="https://apps.apple.com/br/app/forluz/id1195834897" target="_blank" rel="noreferrer">
                    <img className="imagem-fuida" src={appleapp} alt="" title=""></img>
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=br.org.forluz.app&hl=pt_BR" target="_blank" rel="noreferrer">
                    <img className="imagem-fuida" src={googleapp} alt="" title=""></img>
                  </a>
                </div>
              </div>
            </div>
            <p style={{ visibility: "hidden" }}>v.3.3.1</p>
          </div>
        </div>
      </footer>
    </>
  );

}

export default Footer;
